/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumCollectionModelPagedResultSchema } from "../albumCollectionModelPagedResultSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiAlbumCollectionsQueryParamsSchema = z.object({
    "CollectionIds": z.array(z.string().uuid()).describe("Фильтр по идентификаторам выпусков").optional(),
"AuthorIds": z.array(z.string().uuid()).describe("Идентификаторы авторов").optional(),
"SortByName": z.boolean().describe("Сортировка по наименованию").optional(),
"SortByNameDesc": z.boolean().describe("Сортировка по наименованию с конца").optional(),
"SortByAuthor": z.boolean().describe("Сортировка по основному автору").optional(),
"SortByAuthorDesc": z.boolean().describe("Сортировка по основному автору с конца").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список выпусков
 */
export const getApiAlbumCollections200Schema = z.lazy(() => albumCollectionModelPagedResultSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiAlbumCollections400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiAlbumCollections401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiAlbumCollections403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiAlbumCollections500Schema = z.lazy(() => badResponseModelSchema)

export const getApiAlbumCollectionsQueryResponseSchema = z.lazy(() => getApiAlbumCollections200Schema)